export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10708.35be9b0a.jpg";